import moment from 'moment'
import { FilterPeriod } from './enums/filterPeriod.enum'
import { PeriodOptions } from './interfaces/periodOptions.interface'
import en from '../en'

export const getPeriodOptions = (): PeriodOptions => ({
  [FilterPeriod.LAST_30_DAYS]: {
    end: moment().subtract(1, 'day').endOf('day'),
    start: moment().subtract(30, 'days').startOf('day'),
  },
  [FilterPeriod.LAST_7_DAYS]: {
    end: moment().subtract(1, 'day').endOf('day'),
    start: moment().subtract(7, 'days').startOf('day'),
  },
  [FilterPeriod.LAST_90_DAYS]: {
    end: moment().subtract(1, 'day').endOf('day'),
    start: moment().subtract(90, 'days').startOf('day'),
  },
  [FilterPeriod.TODAY]: {
    end: moment().endOf('day'),
    start: moment().startOf('day'),
  },
  [FilterPeriod.YESTERDAY]: {
    end: moment().subtract(1, 'day').endOf('day'),
    start: moment().subtract(1, 'day').startOf('day'),
  },
  [FilterPeriod.LIFETIME]: undefined,
  [FilterPeriod.CUSTOM]: undefined,
})

// Keep for backwards compatibility
export const CONST_PERIOD_OPTIONS: PeriodOptions = getPeriodOptions()

export const PERIOD_OPTIONS_TO_LABELS: Record<FilterPeriod, string> = {
  [FilterPeriod.LAST_30_DAYS]: en.last30Days,
  [FilterPeriod.LAST_7_DAYS]: en.last7Days,
  [FilterPeriod.LAST_90_DAYS]: en.last90Days,
  [FilterPeriod.TODAY]: en.today,
  [FilterPeriod.YESTERDAY]: en.yesterday,
  [FilterPeriod.LIFETIME]: en.lifetime,
  [FilterPeriod.CUSTOM]: en.custom,
}
